import React, {
  useState,
  useEffect,
} from "react";
import {
  Box,
  Container,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import dayjs from "dayjs"
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import { API_Client } from "./api.jsx";
import { useClient } from "./useClient.jsx";
import {
  CollapseStateLabel,
  CollapseDelete,
  CollapseAddLabel,
} from "./CollapseButtons.jsx";
import { set } from "lodash";
import { AddDialog } from "../Components/AddDialog.jsx";
import { empty_uuid, ftchPlus, getOptions, putOptions, scenOption } from "./Account_urls.jsx";
import { InputAge } from "../Components/Inputs/Input_Age.jsx";
import { errorClear, errorSet, errorSetPlus } from "../Components/Inputs/Input_Fns.jsx";
import { InputSelect1, InputSelect1ES, InputSelectN } from "../Components/Inputs/Select.jsx";
import { InputName } from "../Components/Inputs/Input_Name.jsx";
import { InputEmail } from "../Components/Inputs/Input_Email.jsx";
import { InputNumber } from "../Components/Inputs/Input_Number.jsx";
import ValueInflatable from "./ValueInflatable.jsx";
import { InputCheck } from "../Components/Inputs/Input_Check.jsx";
import { useAuth } from "./useAuth.jsx";
import { dateDisabled } from "../Components/Inputs/Dates.jsx";
import { Arrayify } from "../Functions/utils.jsx";
import { InputYear } from "../Components/Inputs/Input_Year.jsx";


const AddPerson = ({ avail, person, onChange, who, onError, scenario }) => {
  const [form, setForm] = useState(person);
  const [pname, setPname] = useState(person.Name)
  const [errors, setErrors] = useState({})

  const onChange_n = (e) => {
    let json = structuredClone(form);
    console.log(e);
    console.log(e.target.value);
    console.log(form);
    json = set(json, e.target.name, Number(e.target.value));
    setForm(json);
    onChange(json);
  };

  const onChange_any = (n, v) => {
    let json = structuredClone(form);
    console.log(n);
    console.log(v);
    console.log(form);
    json = set(json, n, v);
    setForm(json);
    onChange(json);
  };

  const onChange_t = (e) => {
    let json = structuredClone(form);
    console.log(e);
    console.log(e.target.value);
    console.log(form);
    json = set(json, e.target.name, e.target.value);
    setForm(json);
    onChange(json);
  };
  const onChange_name = (e) => {
    let npname = structuredClone(pname);
    npname = set(npname, e.target.name, e.target.value);
    setPname(npname);
    let nf = structuredClone(form);
    nf = set(nf, "Name", npname);
    setForm(nf)
    onChange(nf);
  };

  const onChange_list = (e) => {
    let nf = structuredClone(form);
    console.log(e.target.value);
    console.log(form);
    nf = set(nf, e.target.name, e.target.value);
    setForm(nf);
    validation(nf)
    onChange(nf);
  };

  const onChange_date = (e) => {
    console.log(e);
    let d = e.$y + "-" + (Number(e.$M) + 1).toString() + "-" + e.$D;
    console.log(d);
    let nf = { ...form, Birthday: d };

    setForm(nf);
    console.log(nf);
    onChange(nf);
  };




  // const onBlur = (e) => {
  //   console.log(errors)
  //   let ne = structuredClone(errors)
  //   let err = ""

  //   console.log(e.target.name)
  //   if (e.target.name === "First") {
  //     err = form.Name.First === "" ? "Please Enter a first name" : ""
  //     ne = set(ne, e.target.name, err)
  //   }

  //   setErrors(ne)
  //   console.log(form.Name)
  //   console.log(ne)
  //   console.log(errorJsonHasErrors(ne) ? "Errors" : "")
  //   onError(errorJsonHasErrors(ne) ? "Errors" : "")
  // }

  const validation = (f) => {
  }




  const prefixes = ["", "Mr", "Mrs", "Ms"];


  return (
    <Container maxWidth="true">
      <Box sx={{ my: 2, p: 2, }}>
        <Stack spacing={2} sx={{ my: 2 }}>
          <Typography id="who" variant="h6" gutterBottom>
            {who}
          </Typography>
          <Stack direction="row" spacing={2}>
            <DesktopDatePicker
              maxWidth="false"
              label="Date of Birth"
              inputFormat="MM/DD/YYYY"
              name="Birthday"
              disabled={form.BirthdayDisabled || scenario !== empty_uuid}
              value={dayjs(form.Birthday)}
              //disableFuture
              shouldDisableDate={dateDisabled}
              required
              onChange={onChange_date}
              slotProps={{ textField: { size: "small" } }}
            />
            <InputAge
              label="Life Expectancy"
              name="DieAge"
              width={110}
              age={form.DieAge}
              onChange={onChange_t}
              birthYear={new Date(form.BirthDay).getFullYear()}

            />
            <InputSelect1
              label="Sex"
              name="Sex"
              value={form.Sex}
              minWidth={120}
              onChange={onChange_t}
              errors={errors}
              avail={avail.Sexes}
            />
            <InputSelect1
              label="Marital Status"
              name="MaritalStatus"
              value={form.MaritalStatus}
              minWidth={145}
              onChange={onChange_t}
              errors={errors}
              avail={avail.MaritalTypes}
            />

            <InputCheck
              label="DTC Eligible"
              name="DTCEligible"
              value={form.DTCEligible}
              sx={{ ml: 5, mt: -1, mb: 2 }}
              tooltip="Eligible for the Federal Disability Tax Credit."
              onChange={onChange_any}
            />

          </Stack>
          <Stack direction="row" spacing={2}>
            <InputSelect1ES
              label="Prefix"
              value={form.Name.Prefix}
              onChange={onChange_list}
              name="Name.Prefix"
              disabled={scenario !== empty_uuid}
              minWidth={90}
              avail={prefixes}
            />

            <InputName
              label="First"
              name="First"
              value={pname.First}
              onChange={onChange_name}
              disabled={scenario !== empty_uuid}
              onError={onError}
            />
            <TextField
              label={"Middle"}
              name="Name.Middle"
              size="small"
              type="text"
              value={form.Name.Middle}
              disabled={scenario !== empty_uuid}
              onChange={onChange_t}

            />
            <TextField
              label="Last"
              name="Name.Last"
              size="small"
              type="text"
              value={form.Name.Last}
              disabled={scenario !== empty_uuid}
              onChange={onChange_t}
            />
          </Stack>
          <TextField
            label={"Address"}
            name="Address.Address"
            size="small"
            type="text"
            disabled={scenario !== empty_uuid}
            value={form.Address.Address}
            onChange={onChange_t}
          />
          <TextField
            label={"Address2"}
            name="Address.Address2"
            size="small"
            type="text"
            disabled={scenario !== empty_uuid}
            value={form.Address.Address2}
            onChange={onChange_t}
          />
          <Stack direction="row" spacing={2}>
            <TextField
              label={"City"}
              name="Address.City"
              size="small"
              type="text"
              disabled={scenario !== empty_uuid}
              value={form.Address.City}
              onChange={onChange_t}
            />
            <InputSelect1
              label="Province"
              value={form.Address.ProvState}
              minWidth={110}
              onChange={onChange_t}
              name="Address.ProvState"
              disabled={scenario !== empty_uuid}
              avail={avail.Provinces}
            />
            <TextField
              label={"Postal Code"}
              name="Address.PostalZip"
              size="small"
              type="text"
              value={form.Address.PostalZip}
              disabled={scenario !== empty_uuid}
              onChange={onChange_t}
            />
          </Stack>
          <Stack direction="row" spacing={2}>
            <InputSelect1
              label="Phone"
              value={form.Phone.Type}
              minWidth={90}
              onChange={onChange_t}
              name="Phone.Type"
              disabled={scenario !== empty_uuid}
              avail={avail.PhoneTypes}
            />
            <TextField
              label={"Phone"}
              name="Phone.Number"
              size="small"
              type="text"
              value={form.Phone.Number}
              disabled={scenario !== empty_uuid}
              onChange={onChange_t}
            />
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
};

const defSpouse = {
  Uuid: empty_uuid,
  Birthday: "1973-07-01",
  DieAge: 95,
  DTCEligible: false,
  Name: {
    Prefix: "",
    First: "",
    Middle: "",
    Last: "",
    Suffix: "",
  },
  Address: {
    Address: "",
    Address2: "",
    County: "",
    City: "",
    ProvState: "",
    Country: "",
    PostalZip: "",
  },
  Phone: {
    Type: "Cell",
    Number: "",
  },
  Sex: "Unknown",
  MaritalStatus: "Unknown"
};


const defChild = {
  Birthday: "2020-07-01",
  Name: "",
  Sex: "Unknown",
  SchoolAge: 17,
  SchoolYears: 4,
  SchoolCost: {
    Value: 22000,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
}

const defMove = {
  Id: 0,
  Year: 0,
  Province: "AB",
}

const Child = ({ child, onChange, avail, onError }) => {
  const [form, setForm] = useState(child);
  const [errors, setErrors] = useState({})



  const onChange_date = (e) => {
    console.log(e);
    let d = e.$y + "-" + (Number(e.$M) + 1).toString() + "-" + e.$D;
    console.log(d);
    let nf = { ...form, Birthday: d };

    setForm(nf);
    console.log(nf);
    onChange(nf);
  };
  const onChange_t = (e) => {
    console.log(e);
    console.log(e.target.value);
    console.log(form);
    let nf = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nf);
    onChange(nf);

  };
  const onChangeValue = (name, value, uptoage, SpousePercentage) => {
    console.log(value)
    let nf = {
      ...form,
      [name]: value,
    };
    setForm(nf);
    onChange(nf);
  };

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }



  return (
    <Stack direction="row" spacing={2}>
      <InputName
        label="Name"
        name="Name"
        value={form.Name}
        onChange={onChange_t}
      />
      <DesktopDatePicker
        maxWidth="false"
        label="Date of Birth"
        inputFormat="MM/DD/YYYY"
        name="form.Birthday"
        value={dayjs(form.Birthday)}
        width={130}
        //disableFuture
        required
        onChange={onChange_date}
        slotProps={{ textField: { size: "small" } }}
      />
      <InputSelect1
        label="Sex"
        name="Sex"
        value={form.Sex}
        minWidth={120}
        onChange={onChange_t}
        errors={errors}
        avail={avail.Sexes}
      />
      <InputAge
        label="School Start"
        name="SchoolAge"
        min={14}
        max={40}
        width={100}
        age={form.SchoolAge}
        tooltip="Age on Dec 31 in first year post-secondary education"

        onChange={onChange_t}
      />
      <InputNumber
        label="School Years"
        name="SchoolYears"
        width={100}
        max={16}
        number={form.SchoolYears}
        tooltip="Number of years of post-secondary education expected"
        onChange={onChange_t}
      />
      <ValueInflatable
        form={form.SchoolCost}
        onChange={(e) => onChangeValue("SchoolCost", e)}
        xlabel="School Costs"
        width={100}
        showInf={false}
        avail={avail}
        tooltip="School Costs that you will be responsible for the first year of post-secondary education"
        onError={(e) => myError("value", null, e)}
      />

    </Stack>
  )
}



const Children = ({ children = [], cover, onCover, addChild, onChange, avail, onError }) => {


  const onDelete_i = (name, Id) => {
    let json = children.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange(json);
  };

  return (
    <Box sx={{ ml: 3, mr: 9, my: 2, p: 2, border: "1px solid grey" }}>
      <Stack direction="row" spacing={2}>
        <Stack direction="row" spacing={2}>
          <Typography
            id="Children"
            variant="h6"
            gutterBottom
            sx={{ pt: 1, pl: 3 }}
          >
            Children
          </Typography>
          <CollapseAddLabel
            label="Child"
            onClick={addChild}
            tooltip="Add Child"
            mt={2}
          />
        </Stack>

        <Stack spacing={2}>

          {Arrayify(children).map((v, index) => (
            <Stack key={"stack" + v.Id} direction="row" spacing={2}>
              <Child key={"child-" + v.Id}
                child={v}
                onChange={(f) => { children[index] = f; onChange(children) }}
                avail={avail}
                onError={onError}


              />
              <CollapseDelete
                key={"cd-" + v.Id}
                onClick={() => onDelete_i("Children", v.Id)}
                tooltip="Remove Child"
              />
            </Stack>

          ))}
        </Stack>
        <InputCheck
          label="School Cover"
          name="SchoolCover"
          value={cover}
          onChange={onCover}
          tooltip="Do you want to cover remaining school expenses after RESP is allocated to the costs"


        />

      </Stack>

    </Box>

  )
}

const Move = ({ move, onChange, birthYear, avail, onError }) => {
  const [form, setForm] = useState(move);
  const [errors, setErrors] = useState({})




  const myChange_e = (e) => {
    // console.log(e);
    // console.log(e.target.value);
    // console.log(form);
    let nf = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nf);
    onChange(nf);

  };

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }


  return (
    <Stack direction="row" spacing={2}>
      <InputYear
        year={form.Year}
        birthYear={birthYear}
        onChange={myChange_e}
      />
      <InputSelect1
        label="Province"
        name="Province"
        value={form.Province}
        minWidth={120}
        onChange={myChange_e}
        errors={errors}
        avail={avail.Provinces}
      />

    </Stack>
  )
}


const MoveProvinces = ({ moves = [], birthYear, addMove, onChange, avail, onError }) => {
  const onDelete_i = (name, Id) => {
    let json = moves.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange(json);
  };

  return (
    <Stack direction="row" spacing={2}>
      <Stack direction="row" spacing={2}>
        <Typography
          id="Move"
          variant="h6"
          gutterBottom
          sx={{ pt: 1, pl: 3 }}
        >
          Moves
        </Typography>
        <CollapseAddLabel
          label="Move"
          onClick={addMove}
          tooltip="Add Move"
          mt={2}
        />
      </Stack>

      <Stack spacing={2}>

        {Arrayify(moves).map((v, index) => (
          <Stack key={"stack" + v.Id} direction="row" spacing={2}>
            <Move
              move={v}
              birthYear={birthYear}
              onChange={(f) => { moves[index] = f; onChange(moves) }}
              avail={avail}
              onError={onError}
            />
            <CollapseDelete
              onClick={() => onDelete_i("MoveProvinces", v.Id)}
              tooltip="Remove Move"
            />
          </Stack>

        ))}
      </Stack>
    </Stack>
  )
}


const AddClient = ({ show, onClose, c_uuid, clientJson, c_callback, scenario = empty_uuid }) => {
  const navigate = useNavigate();
  const { admin_r } = useAuth();
  const [admin] = useState(admin_r.current)

  const { setclient_ } = useClient();
  const [form, setForm] = useState(null);
  const [addSpouse, setAddSpouse] = useState(false);
  const [addChildren, setAddChildren] = useState(false);
  const [errors, setErrors] = useState({})



  const Who = ["Client", "Spouse"];

  const getInputData = () => {
    var url = API_Client + c_uuid + scenOption(scenario);
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setForm({
            ...json,
          });
          if (json.Clients[1] && json.Clients[1].Uuid !== empty_uuid) {
            setAddSpouse(true);
          } else {
            setAddSpouse(false);
          }
          validation(json)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const putRequest = async () => {
    console.log(clientJson);

    var url = API_Client + clientJson.uuid + scenOption(scenario);
    var req = putOptions;
    req.body = JSON.stringify(form);
    ftchPlus(url, req)
      .then((response) => {
        console.log(response);
        console.log(clientJson);
        let json = {
          ...clientJson,
          uuid: response.Client.Uuid,
          readonly: form.Locked,
          name: form.Clients[0].Name.First,
          spouseName: addSpouse ? form.Clients[1].Name.First : "",

        };
        c_callback(json);
        setclient_(json);
        myClose(json);
        // if (clientJson.uuid === empty_uuid) {
        //  // move straight to accounts
        //   navigate(APP_setupAccounts);
        // }

      })
      .catch((error) => {
        console.log(error);
      });
  };



  const onSubmit = () => {
    console.log(errors)
    putRequest();
  };



  useEffect(() => {
    errorClear(errors)
    console.log("add client show")
    if (show) {
      getInputData();
    } else {
      setForm(null)
    }
  }, [show]);

  useEffect(() => {
    errorClear(errors)
    console.log("add client cj")
    if (show) {
      getInputData();
    }
  }, [clientJson]);

  const onChange_any = (name, value) => {
    let nf = setForm({
      ...form,
      [name]: value,
    });
    return nf
  }

  const onChange_t = (e) => {
    console.log(e);
    console.log(e.target.value);
    console.log(form);
    onChange_any(e.target.name, e.target.value)
  };
  const onChange_list = (e) => {
    const value = e.target.value;
    const values = typeof value === "string" ? value.split(",") : value;

    console.log(values);
    console.log(form);
    let nf = {
      ...form,
      [e.target.name]: values,
    }
    setForm(nf)
    console.log(nf);
    validation(nf)
  };

  const extraValidation = (f, e) => {
    let ne = structuredClone(e)

    let err = (f.TaxRegimes.length !== 2) ? "Please add Canada and one province" : ""
    ne = set(ne, "TaxRegimes", err)

    setErrors(ne)
    return ne
  }

  // const myErrorSet = (obj, i, err) => {
  //   if (i !== null) {
  //     obj += "[" + i + "]"
  //   }
  //   extraValidation(form, obj, err)
  // }
  const myErrorSet = (obj, i, err) => {
    let ne = errorSet(errors, setErrors, obj, i, err)
    extraValidation(form, ne)

  }

  const validation = (f) => {
    extraValidation(f, errors)

  }


  const onPersonChange = (i, c) => {
    //console.log(i, c);
    let path = "Clients[" + i + "]";
    let nf = set(form, path, c);
    setForm(nf);
    //console.log("index:" + i);
    //console.log(nf);
  };

  const removeSpouse = () => {
    let path = "Clients[1]";
    let nf = set(form, path, defSpouse);
    nf = { ...nf, AddSpouse: false };

    setForm(nf);
    setAddSpouse(false);
    errorClear()
  };
  const addSpouse_ = () => {
    let path = "Clients[1]";
    let nf = set(form, path, defSpouse);
    nf = { ...nf, AddSpouse: true };
    setForm(nf);
    setAddSpouse(!addSpouse);
  };

  const myClose = (json) => {
    onClose(json)
  }
  const addChild = (e) => {
    let c = structuredClone(defChild);
    let json = [];
    if (form.Children) {
      json = form.Children.slice();
      c.Id = Math.max(...form.Children.map((o) => o.Id), 0) + 1;
    }
    // console.log(n_init);
    json.push(c);
    let nf = structuredClone(form);
    nf = { ...nf, Children: json };
    console.log(nf)
    setForm(nf);
  };

  const onChange_children = (c) => {
    console.log(c)

    let nf = structuredClone(form);
    nf = { ...nf, Children: c };
    console.log(nf)
    setForm(nf);
  }
  const myAddMove = (e) => {
    let c = structuredClone(defMove);
    let json = [];
    if (form.MoveProvinces) {
      json = form.MoveProvinces.slice();
      c.Id = Math.max(...form.MoveProvinces.map((o) => o.Id), 0) + 1;
    }
    // console.log(n_init);
    json.push(c);
    let nf = structuredClone(form);
    nf = { ...nf, MoveProvinces: json };
    console.log(nf)
    setForm(nf);
  };
  const myChange_move = (c) => {
    console.log(c)

    let nf = structuredClone(form);
    nf = { ...nf, MoveProvinces: c };
    console.log(nf)
    setForm(nf);
  }



  return (

    <AddDialog
      onClose={() => myClose({})}
      open={show}
      onSubmit={onSubmit}
      clientJson={clientJson}
      c_callback={c_callback}
      label="Client Information"
      accountType="Client"
      errors={errors}
      locked={form === null ? null : form.Locked}
    >
      {form &&
        form !== null && (
          <Stack sx={{ mx: 4 }}>
            <InputEmail
              sx={{ ml: 3, width: 400 }}
              value={form.ClientEmail}
              name="ClientEmail"
              onChange={onChange_t}
              disabled={scenario !== empty_uuid}
              onError={(e) => { myErrorSet("email", null, e) }}
            />
            <Stack direction="row" spacing={2}>
              {/* {form.Clients.map((c, i) => (
              <AddPerson
                key={uuidv4()}
                avail={form.Avail}
                person={c}
                index={i}
                who={Who[i]}
                onChange={onPersonChange}
              />
            ))} */}
              {form.Clients && (
                <AddPerson
                  key={"client-add"}
                  avail={form.Avail}
                  person={form.Clients[0]}
                  who={Who[0]}
                  onChange={(v) => onPersonChange(0, v)}
                  onError={(e) => { myErrorSet("client", null, e) }}
                  scenario={scenario}
                />
              )}
              <Stack>
                {(scenario === empty_uuid &&
                  <CollapseStateLabel
                    add={addSpouse}
                    onClick={addSpouse_}
                    label="Spouse"
                  />
                )}
              </Stack>

              {addSpouse && (
                <>
                  <AddPerson
                    key={"spouse-add"}
                    avail={form.Avail}
                    person={form.Clients[1]}
                    who={Who[1]}
                    onChange={(v) => onPersonChange(1, v)}
                    onError={(e) => { myErrorSet("spouse", null, e) }}
                    scenario={scenario}
                  />
                  <Stack sx={{ py: 4 }}>
                    {(scenario === empty_uuid &&
                      <CollapseDelete key={"cd-"} onClick={removeSpouse} />
                    )}
                  </Stack>
                </>
              )}
            </Stack>
            <Box sx={{ ml: 3, mr: 9, my: 2, p: 2, border: "1px solid grey" }}>
              <Stack direction="row" spacing={2}>
                <Typography
                  id="Tax-regime"
                  variant="h6"
                  gutterBottom
                  sx={{ pt: 1, pl: 3 }}
                >
                  Tax
                </Typography>

                <InputSelectN
                  label="Tax Jurisdictions"
                  name="TaxRegimes"
                  value={form.TaxRegimes}
                  onChange={onChange_list}
                  minWidth={200}
                  errors={errors}
                  required
                  avail={form.Avail.TaxRegimes}
                />
                <MoveProvinces
                  moves={form.MoveProvinces}
                  birthYear={(Array.isArray(form.Clients) && form.Clients.length > 0) ? new Date(form.Clients[0].Birthday).getFullYear() : 0}
                  addMove={myAddMove}
                  avail={form.Avail}
                  onChange={myChange_move}
                  onError={(e) => { myErrorSet("move", null, e) }}
                />

              </Stack>
            </Box>
            <Children
              children={form.Children}
              addChild={addChild}
              avail={form.Avail}
              onChange={onChange_children}
              cover={form.SchoolCover}
              onCover={(n, v) => onChange_any(n, v)}
              onError={(e) => { myErrorSet("spouse", null, e) }}
            />
            <Box
              sx={{
                ml: 3,
                mr: 9,
                my: 2,
                p: 2,
                mb: 4,
                border: "1px solid grey",
              }}
            >
              <Stack spacing={2}>
                <Stack direction="row" spacing={2}>
                  <Typography
                    id="s-die-age-slider"
                    variant="h6"
                    gutterBottom
                    sx={{ pt: 1, pl: 3 }}
                  >
                    Access
                  </Typography>
                  <InputCheck
                    label="Locked"
                    value={form.Locked}
                    name="Locked"
                    onChange={(n, v) => onChange_any(n, v)}
                    disabled={scenario !== empty_uuid}
                    sx={{ pl: 4 }}
                  />
                  <InputCheck
                    label="Public"
                    value={form.Public}
                    name="Public"
                    onChange={(n, v) => onChange_any(n, v)}
                    disabled={!(admin || form.Public)}
                    sx={{ pl: 4, pr: 8 }}
                  />
                  <TextField
                    label="Share With Email"
                    name="ShareEmail"
                    type="text"
                    value={form.ShareEmail}
                    required={false}
                    //maxLength={63}
                    size="small"
                    sx={{ width: 200 }}
                    disabled={scenario !== empty_uuid}
                    onChange={onChange_t}
                  />
                  <InputCheck
                    label="ShareConnected"
                    value={form.ShareConnected}
                    disabled={true}
                    onChange={() => { }}
                  />

                </Stack>
                <Stack direction="row">
                  <Typography
                    variant="body"
                    gutterBottom
                    sx={{ pt: 1, pl: 3 }}

                  >
                    Restrictions:
                  </Typography>
                  <Typography
                    variant="body"
                    gutterBottom
                    sx={{ pt: 1, pl: 3 }}
                    color={form.Restrictions ? "error" : "default"}
                    fontWeight={form.Restrictions ? "bold" : "default"}
                  >
                    {form.Restrictions ? form.Restrictions : "<none>"}
                  </Typography>
                </Stack>
                <TextField
                  label="Comments - Why is this interesting"
                  name="AccessDescription"
                  type="text"
                  value={form.AccessDescription}
                  required={false}
                  disabled={scenario !== empty_uuid}
                  maxLength={256}
                  size="small"
                  //sx={{ width: 200 }}
                  onChange={onChange_t}
                />
              </Stack>
            </Box>
          </Stack>
        )}
    </AddDialog>

  );
};

export default AddClient;
